import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';
import {
  GIFT_PAGE_BG_IMG_URL_MOBILE,
  GIFT_PAGE_BG_IMG_URL_TABLET,
} from '@utils/data';

export const useStyles = makeStyles({
  heroSectionContainer: {
    position: 'relative',
    backgroundImage: `url(${GIFT_PAGE_BG_IMG_URL_MOBILE})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.up(500)]: {
      backgroundImage: `url(${GIFT_PAGE_BG_IMG_URL_TABLET})`,
    },
    [theme.breakpoints.up(800)]: {
      background: theme.palette.cinnamon.main,
    },
  },

  titleWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px 25px 90px',

    [theme.breakpoints.up(500)]: {
      padding: '80px 25px 130px',
      //padding: '105px 0 85px',
    },

    [theme.breakpoints.up(800)]: {
      padding: '25px 25px 35px',
      //padding: '105px 0 85px',
    },
  },

  tilte: {
    //textShadow: '0px 15px 10px rgba(0, 0, 0, 0.5)',
    [theme.breakpoints.down('sm')]: {
      //width: '290px',
    },
  },

  faqReleated: {
    padding: '0 25px',

    [theme.breakpoints.up('sm')]: {
      padding: '0 50px',
    },

    [theme.breakpoints.up('lg')]: {
      maxWidth: 'md',
    },
  },

  boldUnderline: {
    textDecoration: 'underline',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
});
